import { escapeHtml as esc } from './escapeHtml.js';
/**
 * Category-mastery summary chip, shared by the Misdeeds and Good Deeds pages.
 * Renders nothing until the player has at least one Triumph in the category.
 */
import type { CategoryMasteryDto } from '@rex-mortis/shared';

const ROMAN = ['', 'I', 'II', 'III', 'IV', 'V'];

export function masteryChipHtml(m: CategoryMasteryDto | undefined): string {
  if (!m || m.triumphs <= 0) return '';
  const label = m.level > 0 ? `Mastery ${ROMAN[m.level]}` : 'Mastery';
  const progress =
    m.nextAt !== null
      ? `${m.triumphs.toLocaleString()} / ${m.nextAt.toLocaleString()}`
      : `${m.triumphs.toLocaleString()} · Grandmaster`;
  const tip =
    m.level > 0
      ? `${m.epithet} — −${Math.round(m.resolveDiscountPct * 100)}% Resolve and +${Math.round(m.dropChanceBonus * 100)}% loot chance across this calling. Every Triumph counts toward the next rank.`
      : 'Every Triumph in this calling counts toward Mastery — ranks grant a Resolve discount and better loot odds.';
  return ` <span class="pill" style="font-size:0.78rem; margin-left:8px;" title="${esc(tip)}">${esc(label)} · ${progress}</span>`;
}
